'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getDateTimeParts = require('./get-date-time-parts.js');
var isSameMonth = require('./is-same-month.js');

function isSameDay(date1, date2, timeZone) {
  const {
    day: day1
  } = getDateTimeParts.getDateTimeParts(date1, timeZone);
  const {
    day: day2
  } = getDateTimeParts.getDateTimeParts(date2, timeZone);
  return isSameMonth.isSameMonth(date1, date2, timeZone) && day1() === day2();
}

exports.isSameDay = isSameDay;
